import React, { PropsWithChildren } from "react";
import { Icon, List } from "semantic-ui-react";
import { WidgetProps } from "@rjsf/core";
import ImageInput from "../../../../sg-fileupload/components/ImageInput";
import { IFileUploadElementProps } from "../../../../sg-fileupload/components/FileUpload";
import Image from '../../../../sg-fileupload/components/Image'
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

const getTextProps = (t: TFunction) => ({
  downloadImageByDraggingOrClickHere: t("Lataa kuva raahaamalla se tähän tai napsauttamalla"),
});

const InputElement: React.FC<PropsWithChildren<IFileUploadElementProps>> = ({ children, isDragActive }) => {
  const texts = getTextProps(useTranslation().t);
  return (
    <div className={`drop zone ${isDragActive && "loading"}`}>
      <div className="drop icon">
        <Icon.Group size="big">
          <Icon name="circle outline" size="large" fitted color="grey" />
          <Icon name="camera" size="small" color="grey" />
        </Icon.Group>
      </div>
      <div className="drop text">
        {texts.downloadImageByDraggingOrClickHere}
        {children}
      </div>
    </div>
  );
};


interface IFileUpload6 extends WidgetProps {
  type?: string
}

const FileUpload6 = (props: IFileUpload6) => {
  const {
    disabled,
    value,
    onChange,
    readonly,
  } = props


  const onAddImage = (newImages: { id: string; name: string }[]) => {
    onChange && onChange((value || []).concat(newImages))
  };

  const onRemovedImage = (guid: string) => {
    onChange && onChange(value.filter((file: any) => file.id !== guid))
  };

  if (readonly) {
    return (
      <List className="ImageList" horizontal>
        {(value || []).map((file: any) => (
          <List.Item key={file.id}>
            <Image
              className="ImageList_img"
              id={file.id}
            />
          </List.Item>
        ))}
      </List>
    )
  }


  return (
    <ImageInput
      multiple
      inputAreaElem={InputElement}
      onUploaded={onAddImage}
      onRemoved={onRemovedImage}
      files={value || []}
      disabled={disabled || readonly}
    />
  );
}

export default FileUpload6;
